export default function Dot() {
  return (
    <div className='mx-1.5 size-2 min-h-[8px] min-w-[8px] rounded-full bg-foreground/40' />
  );
}
